const URL = {
  AI_AGENT_SESSION: '/api/agent/sessions/',
};

export const model = {
  init: () => URL.AI_AGENT_SESSION,
  sendNewChatMessage: (sessionId?: number) => `${URL.AI_AGENT_SESSION}${sessionId}/chat/`,
};
